
import { defineComponent, onMounted, ref } from 'vue'
import BaseModal from '../base/BaseModal.vue';
import localforage from 'localforage';
import { auth } from '@/plugins/firebase';


const MODAL_OPEN_KEY = 'modal_opened_today';

export default defineComponent({
  components: { BaseModal },

  setup () {
    const isSending = ref(false);

    const isActive = ref(false);

    const toggle = () => {
      isActive.value = !isActive.value;
    };

    const isSameDay = (storedDate: string) => {
      const today = new Date().toISOString().split('T')[0];
      return storedDate === today;
    };

    const checkModalStatus = async (): Promise<boolean> => {
      try {
        const storedDate = await localforage.getItem<string>(MODAL_OPEN_KEY);

        if (!storedDate || !isSameDay(storedDate)) {
          await localforage.setItem(MODAL_OPEN_KEY, new Date().toISOString().split('T')[0]);
          return true; // O modal deve ser aberto
        }
      } catch (error) {
        console.error('Erro ao verificar o status do modal:', error);
      }
      return false; // O modal não deve ser aberto
    }

    const openModalIfNeeded = async () => {
      const shouldOpen = await checkModalStatus();
      if (shouldOpen) {
        isActive.value = true;
      }
    };

    const ctaClick = async () => {
      const letsGo = confirm('Você será redirecionado para a nova versão da Manycontent. Deseja continuar?');

      if (letsGo) {
        await localforage.clear()
        window.localStorage.clear()
        await auth.signOut()
        window.location.href = 'https://business.manycontent.com/auth/login'
      }
    }

    onMounted(() => {
      setTimeout(openModalIfNeeded, 5000);
    });

    return {
      isActive,
      isSending,
      toggle,
      ctaClick
    }
  }
})
